import React from "react";
import { skills } from "../constants/skills";
import Bounce from "react-reveal/Bounce";

import { IoIosAdd as AddIcon } from "react-icons/io";

const Skills = () => {
  return (
    <div
      className="py-20 flex  min-h-screen mb-3 justify-center max-w-6xl mx-auto items-center"
      id="skills"
    >
      <div className="w-full p-4">
        <h2 className="md:text-8xl text-6xl font-bold text-center md:text-left text-transparent bg-clip-text bg-gradient-to-r from-[#DD2476] via-[#FB680B] to-[#FF522C]">
          My Skills
        </h2>
        <Bounce right cascade>
          <div className="grid md:grid-cols-4 grid-cols-2 my-20 w-full gap-2">
            {skills?.map((item, index) => (
              <div
                className={`flex w-full text-center text-xl mb-3 ${item?.color}`}
                key={index}
              >
                <AddIcon className={item?.color} />
                {item?.title}
              </div>
            ))}
          </div>
        </Bounce>
      </div>
    </div>
  );
};

export default Skills;
